import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import selectors from '../selectors/selectors.js';
import { publishAction } from 'redux/actions/messagesActions.js';

const PublishRealtimeRecordViewing = () => {
  const nonLeadIdEventId = useSelector(selectors.eid);
  const leadId = useSelector(selectors.lead);
  const user = useSelector((state) => state.user);
  const userId = (user || {}).id;
  const userName = user && user.profile ? `${user.profile.first_name} ${user.profile.last_name}` : '';

  useEffect(() => {
    const viewingRecordData = {
      event: 'viewing_record',
      key: `viewing_record`,
      message: { id: leadId ? leadId : nonLeadIdEventId, initials: userName, userId },
    };
    publishAction({ data: viewingRecordData });
  }, [leadId, nonLeadIdEventId, userId]);

  return null;
};

export default PublishRealtimeRecordViewing;
